import React from 'react';
import { Filter, X } from 'lucide-react';
import { FLEET_USAGE_OPTIONS, FLEET_OWNERSHIP_OPTIONS, FLEET_ENGINE_OPTIONS, DEFAULT_FLEET_FILTERS, isFleetFilterActive } from '../../utils/fleetFilters';

const SELECT_CLS = 'bg-ink-900 border border-ink-600 rounded-md px-2 py-1 text-[11px] text-slate-200 focus:outline-none focus:border-accent';

function Select({ id, label, value, options, onChange, testId }) {
  return (
    <label className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-slate-500">
      {label}
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} className={SELECT_CLS} data-testid={testId}>
        {options.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
    </label>
  );
}

/** Flotte — barre de filtres (catégorie / utilisation / propriété / motorisation). */
export default function FleetFilters({ filters, onChange, total, shown }) {
  const tiers = [{ id: 'all', label: 'Tous' }, ...[1, 2, 3, 4, 5].map((t) => ({ id: String(t), label: `Tier ${t}` }))];
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  const active = isFleetFilterActive(filters);
  return (
    <div className="bg-ink-800 rounded-lg border border-ink-600 px-3 py-2 flex items-center gap-3 flex-wrap" data-testid="fleet-filters">
      <span className="flex items-center gap-1 text-[10px] uppercase tracking-wider text-slate-400 font-bold"><Filter className="w-3.5 h-3.5" /> Filtres</span>
      <Select id="fleet-filter-tier" label="Catégorie" value={filters.tier} options={tiers} onChange={set('tier')} testId="fleet-filter-tier" />
      <Select id="fleet-filter-usage" label="Utilisation" value={filters.usage} options={FLEET_USAGE_OPTIONS} onChange={set('usage')} testId="fleet-filter-usage" />
      <Select id="fleet-filter-ownership" label="Propriété" value={filters.ownership} options={FLEET_OWNERSHIP_OPTIONS} onChange={set('ownership')} testId="fleet-filter-ownership" />
      <Select id="fleet-filter-engine" label="Motorisation" value={filters.engine} options={FLEET_ENGINE_OPTIONS} onChange={set('engine')} testId="fleet-filter-engine" />
      <span className="ml-auto text-[11px] text-slate-500" data-testid="fleet-filter-count">{shown}/{total} véhicule{total > 1 ? 's' : ''}</span>
      {active && (
        <button type="button" onClick={() => onChange(DEFAULT_FLEET_FILTERS)} className="inline-flex items-center gap-1 text-[11px] text-accent hover:underline" data-testid="fleet-filter-reset">
          <X className="w-3 h-3" /> Réinitialiser
        </button>
      )}
    </div>
  );
}
